import { Box, Button, Stack } from "@mui/material";
import { useState } from "react";
// import
import { useTranslation } from "react-i18next";

import SchoolLeaderboardTable from "./SchoolLeaderboardTable";
import SchoolLeaderboardQueryForm from "./SchoolLeaderboardQueryForm";
import { AdminApi } from "../../api/AdminApi";
import downloadCsvData from "../../helper/DownloadHelper"


const sampleResults = [
    {
        id: 42,
        name_zh: "可信Jumping Jack",
        name_en: "Hoshun Jump Jack",
        code: "hoshun_jumping_jack",
        fitness_type: "hoshun_jumping_jack",
        fitness_type_en: "Hoshun Jump Jack",
        fitness_type_zh: "可信Jumping Jack",
        unit: "score",
        decimal_place: 0,
        rank_direction: "desc",
        support_ipad: true,
        color: "blue",
        result: [
            {
                rank: 1,
                score: "22",
                unit: "",
                participants: [
                    { type: "member", member_id: "18357", name: "趙 焌 傑", school_cls: "2B" },
                    { type: "member", member_id: "18713", name: "劉 嘉 妍", school_cls: "5A" },
                    { type: "member", member_id: "18842", name: "趙 芷 雯", school_cls: "4B" }
                ]
            },
            {
                rank: 2,
                score: "21",
                unit: "",
                participants: [
                    { type: "member", member_id: "18371", name: "陸 宇 軒", school_cls: "2B" },
                    { type: "member", member_id: "18397", name: "簡 梓 雅", school_cls: "2C" }
                ]
            },
            {
                rank: 3,
                score: "20",
                unit: "",
                participants: [
                    { type: "member", member_id: "18795", name: "羅 梓 瑜", school_cls: "5D" }
                ]
            },
            {
                rank: 4,
                score: "19",
                unit: "",
                participants: [
                    { type: "member", member_id: "18467", name: "陳 詩 妍", school_cls: "3B" },
                    { type: "member", member_id: "18484", name: "孫 銘 浩", school_cls: "3B" }
                ]
            },
            {
                rank: 5,
                score: "18",
                unit: "",
                participants: [
                    { type: "member", member_id: "18763", name: "何 紫 慧", school_cls: "5C" },
                    { type: "member", member_id: "18885", name: "馬 福 熙", school_cls: "4D" }
                ]
            },
            {
                rank: 6,
                score: "17",
                unit: "",
                participants: [
                    { type: "member", member_id: "18489", name: "王 梓 蕘", school_cls: "3B" },
                    { type: "member", member_id: "18840", name: "陳 彥 羽", school_cls: "4B" },
                    { type: "member", member_id: "18891", name: "黃 凱 婷", school_cls: "4D" }
                ]
            }
        ]
    }
]


function getLeadboardTable(leaderboard) {
    if (leaderboard == null) {
        return <Box>請修改查詢條件，並按“查詢”按鈕</Box>;
    }

    const leaderboardItems = leaderboard.map((item) => {
        return <SchoolLeaderboardTable key={item.id} leaderboardSkillRecord={item} />
    });

    return (
        <Stack dirction="column">
            {leaderboardItems}
        </Stack>);
}

function generateCsvData(mode, leaderboard) {
    console.debug("generateCsvData: ", leaderboard);
    // Generate CSV data from eventStat and skillStatList
    let headerColumns = [
        "Skill Name",
        "Rank",
        "Score",
        "Name",
        // "Member Name",
        // "Phone Number",
        // "QR Code",
    ];
    if (mode == 'student') {
        headerColumns.push('Class');
    }

    let csvData = [];

    // Add header row
    csvData.push(headerColumns);

    // // loop through skillStatList
    for (let skillData of leaderboard) {
        const skillCode = skillData.code || "";
        const skillName = skillData.name_zh || skillCode;

        const topRecords = skillData.result || [];
        // let rank = 1;
        for (let data of topRecords) {
            let rank = data.rank || 0;
            let score = data.score || 0;
            let participants = data.participants || [];

            for (let participant of participants) {

                let name = participant.name || "";
                // let phone = member.phone_num || "";
                // let qrcodeID = member.qrcode_id || "";

                let schoolClass = "";
                if (mode == 'student') {
                    schoolClass = participant.school_cls || "";
                }

                csvData.push([
                    skillName,
                    rank,
                    score,
                    name,
                    schoolClass
                    // phone,
                    // qrcodeID,
                ]);
            }

        }

    }

    console.log("mode", mode);
    console.debug("csvData: ", csvData);

    return csvData;

}



export default function SchoolLeaderboardSection({ orgID }) {
    const [leaderboard, setLeaderboard] = useState(null);
    const [mode, setMode] = useState("student");
    const [filters, setFilters] = useState(null);

    const { t } = useTranslation();

    const hasQuery = leaderboard !== null;

    const leaderboardTable = getLeadboardTable(leaderboard);

    // const onQueryLeaderboard = (query) => {
    //     console.debug("Query: ", query);
    // }

    const onQueryLeaderboard = ({ mode, filters }) => {
        console.debug("onQueryLeaderboard: ", { mode, filters });
        // const mode = 'student';
        setMode(mode);
        setFilters(filters);

        let callback = (isSuccess, msg, result) => {
            if (isSuccess) {
                setLeaderboard(result);
                // alert("Success");
            } else {
                alert("Failed to load leaderboard: " + msg);
            }
            // console.debug("result: isSuccess=", isSuccess,
            //     " msg=", msg, " result=", result);
        }
        // AdminApi.getSchoolLeaderboardCallback(orgID, mode, filters, callback);
        AdminApi.getSchoolLeaderboardCallback(orgID, mode, filters, callback);
    }

    const onExportCSV = async () => {
        const csvData = generateCsvData(mode, leaderboard);
        const filename = `leaderboard.csv`;

        console.log("csvData", csvData);
        downloadCsvData(csvData, filename);
        // console.debug("csvData: ", csvData);
        // console.debug("filename: ", filename);
        // downloadCsvData(csvData, filename);
    };

    const onShowBillboard = () => {
        console.log("onShowBillboard...: mode=", mode, " filters=", filters);

        // Navigate to billboard page
        let year = filters.year || 2024;
        let dateRangeType = filters.dateRangeType || "semester1";

        let yearLeaderboardLink = `/userYearLeaderboardBillboard?year=${year}&dateRangeType=${dateRangeType}&mode=${mode}`;

        window.open(yearLeaderboardLink, '_blank').focus();
    };

    //     const result = await AdminApi.loadEventLeaderboardData(eventID, startDate, endDate);
    //     console.debug("result: ", result);
    //     if (result) {
    //       setSkillID(skillID);
    //       setLeaderboard(result);
    //       // alert("Success");
    //     } else {
    //       alert("Failed to load leaderboard");
    //     }
    //   };

    return (
        <Stack direction="column" spacing={2}>
            <SchoolLeaderboardQueryForm
                onQuery={onQueryLeaderboard}>

            </SchoolLeaderboardQueryForm>

            {
                hasQuery &&
                <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                    <Button variant="contained" onClick={onExportCSV}>
                        {t("button.export_csv")}
                    </Button>
                    <Button variant="contained" onClick={onShowBillboard}>
                        顯示排行榜
                    </Button>
                </Stack>
            }


            {leaderboardTable}
            <Box>
                <pre>
                    {/* isAdminUser: {isAdminUser ? "true" : "false"}<br />
          userID: {userID}<br /> */}
                    {/* {JSON.stringify(eventList, null, 2)} */}

                    {/* {JSON.stringify(leaderboard, null, 2)} */}
                    {/* {JSON.stringify(event, null, 2)} */}
                </pre>
            </Box>

        </Stack>
    );
}